import script from "./MarketplaceReviews.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketplaceReviews.vue?vue&type=script&setup=true&lang=ts"

import "./MarketplaceReviews.vue?vue&type=style&index=0&id=39e8c9bd&lang=scss"

const __exports__ = script;

export default __exports__